const STORAGE_KEY = 'sidebar_open';

const getInitialState = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    // First visit (nothing stored) → expanded by default
    return stored === null ? true : stored === 'true';
  } catch (_e) {
    return true;
  }
};

let currentState = getInitialState();
const listeners = new Set();

export const getState = () => currentState;

export const toggle = () => {
  currentState = !currentState;
  try {
    localStorage.setItem(STORAGE_KEY, String(currentState));
  } catch (_e) {
    // localStorage not available — continue without persistence
  }
  listeners.forEach((fn) => fn(currentState));
};

export const subscribe = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};
